export function strIs(str) {
  return str !== null && str !== undefined && str.toString().trim() !== "";
}

export function removeEmptyLines(value) {
  if (!strIs(value)) return "";
  return value
    .toString()
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter((line) => strIs(line))
    .join("\n");
}

export function deepCopyJSONObject(source) {
  // https://stackoverflow.com/questions/122102/what-is-the-most-efficient-way-to-deep-clone-an-object-in-javascript
  // There are a range of ways to deep copy a JSON object, but nothing built in to the JS core.
  // This looks nasty but it will recursively deep copy strings and numbers.
  // Don't use this if you want to deep clone JSON objects that contain functions
  return JSON.parse(JSON.stringify(source));
}

export function waiterToCloseSnackBar(method, timeout) {
  return setTimeout(async () => await method, timeout);
}
